import type { vendorApiNames } from '../names';
import type {
  ApiTokenAuthentication,
  UsernamePasswordAuthentication,
} from './auth';
import type {
  BaseUpdateVendorApiSettings,
  BaseUrl,
  BaseVendorApi,
  RejectUnauthorized,
} from './base';
import type {
  VendorApiHttpAdvancedSettings,
  VendorApiHttpAgentSettings,
} from './http';
import type { VendorApiSessionSettings } from './session';
import type { WebsocketParsingOptions, WebsocketTimeouts } from './ws';

/**
 * VeloCloud API settings available from API
 */
export type PublicVeloCloudApiSettings = BaseVendorApi<
  (typeof vendorApiNames)['velocloud']
> &
  RejectUnauthorized &
  BaseUrl &
  VendorApiHttpAgentSettings &
  VendorApiSessionSettings &
  VendorApiHttpAdvancedSettings &
  WebsocketTimeouts &
  WebsocketParsingOptions & {
    veloCloudWsCommandMaxAttempts?: number; // number of max attempts to send a websocket command
    veloCloudWsCommandRetryDelayMs?: number; // delay before retrying a failed websocket command
  };

/**
 * VeloCloud API settings available in backend
 */
export type VeloCloudApiSettings = PublicVeloCloudApiSettings &
  (ApiTokenAuthentication | UsernamePasswordAuthentication);

/**
 * VeloCloud API settings expected on API when updating
 */
export type UpdateVeloCloudApiSettings = BaseUpdateVendorApiSettings<
  PublicVeloCloudApiSettings,
  ApiTokenAuthentication | UsernamePasswordAuthentication
>;
